var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStoreResetActive = function SvgStoreResetActive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 1.35
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M22.575 11.627l-1.45 2.883-3.088-1.555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7 13.773C9.333 11.04 11.844 9 14.846 9c3.214 0 5.865 2.34 6.252 5.362"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M11.48 18.434l-2.755-1.607-1.668 2.996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.146 17.464c-.633 2.732-3.144 4.773-6.146 4.773-3.214 0-5.865-2.34-6.252-5.362"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStoreResetActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/store-reset-active.09c926fa03f876110bfe8f5e786005f9.svg";